import type { CitationData, CitationMessageBlock } from "@/lib/chat-types";
import { readString, resolveString, toRecord } from "@/lib/fund-compliance/parse-primitives";

/* ── Field resolution keys ───────────────────────────────────────── */

const EXCERPT_KEYS = ["excerpt", "text", "quote"] as const;
const TITLE_KEYS = ["sourceTitle", "title"] as const;

/* ── Public API ──────────────────────────────────────────────────── */

export function extractCitationBlocks(value: unknown): CitationMessageBlock[] {
  if (!Array.isArray(value)) return [];

  return value
    .map((item) => {
      const record = toRecord(item);
      if (!record) return null;

      const text = resolveString(record, EXCERPT_KEYS);
      if (!text) return null;

      const sourceTitle = resolveString(record, TITLE_KEYS);

      const sourceParts = [
        sourceTitle,
        typeof record.page === "number" ? `p. ${record.page}` : undefined,
        typeof record.score === "number" ? `score ${record.score.toFixed(2)}` : undefined,
      ].filter(Boolean) as string[];

      const citation: CitationData = {
        text,
        source: sourceParts.join(" \u00b7 ") || readString(record.id) || "Citation",
        sourceTitle,
        page: typeof record.page === "number" ? record.page : undefined,
        score: typeof record.score === "number" ? record.score : undefined,
        citationId: readString(record.id),
      };

      return { type: "citation", citation } satisfies CitationMessageBlock;
    })
    .filter((block): block is CitationMessageBlock => block !== null);
}
